import {EntityWithId, EntityWithIdAndDescription} from "../baseEntities";
import {Channels} from "../generalData";
import {ClientFields} from "../client/clientData";
import {FileBase} from "./solicitationFile";
import {SolicitudPreviewEstados} from "../../pages/solicitations/dummyTypes";

export enum SolicitationFields {
    SolicitationChannelCode = 'codSolicitudCanal',
    SolicitationClientId = 'idSolicitudCliente',
    SolicitationStateCode = 'codSolicitudEstado',
    SolicitationTypeCode = 'codSolicitudTipo',
    AfipActivityCode = 'codAfipActividad',
    AnualIncome = 'importeIngresoAnual',
    BeginDate = 'fechaAlta',
    RegisterUserId = 'idUsuarioAlta',
    LastModifiedUserId = 'idUsuarioUltMod',
    NosisDataConsulted = 'consultoDatosNosis',
    OriginId = 'idSolicitudEnOrigen',
    SolicitationGuaranteeTypeCode = 'codSolicitudGarantiaTipo',
    EmployeeQuantity = 'cantEmpleados',
    NewEmployeeQuantity = 'cantEmpleadosIncorporar',
    GenderQuota = 'porcFemeninasEnCargosGerarquicos',
    CommunicationChannelCode = 'codComunicacionCanal',
    CommercialOriginId = 'idOrigenComercial',
    InstallmentCTAmount = 'importeCuotasMensualesCT',
    InstallmentInvAmount = 'importeCuotasMensualesInv',
    InstallmentAgroAmount = 'importeCuotasMensualesAgro',
    BankCode = 'codBanco',
    BranchCode = 'codBancoSucursal',
    CommercialId = 'idComercial',
    TitularId = 'idClienteTitular',
    TitularBusinessName = 'razonSocialTitular',
    TitularCUIT = 'cuitTitular',
    SolicitationStateDesc = 'descSolicitudEstado',
    SolicitationTypeDesc = 'descSolicitudTipo',
    RegisterUser = 'usuarioAlta',
    SolicitationGuaranteeTypeDesc = 'solicitudGarantiaTipo',
    BankDesc = 'bancoNombre',
    BranchDesc = 'bancoSucursalNombre',
    CurrentStage = 'etapaActual',
    AfipActivityDesc = 'descAfipActividad',
    AfipAreaDesc = 'descAfipRubro',
    AfipSectorDesc = 'descAfipSector',
    SolicitationChannelDesc = 'descSolicitudCanal',
    ModuleCode = 'codModulo',
    HasCoOwner = 'tieneCotitular',
    ExternalResponsibleUser = 'usuarioResponsableExterno',
    ExternalResponsibleUserId = 'idUsuarioResponsableExterno',
    Mail = 'mail',
    Amount = 'montoSolicitado',
    OperationDestinationReasonDesc = 'descOperacionDestinoMotivoSolicitado',
    OperationDestinationDesc = 'descOperacionDestinoSolicitado',
    SentDate = 'fechaEnvio',
    HasActiveNotification = 'tieneNotificacionActiva',
    AchievedDocumentsQuantity = 'cantidadDocumentosAnexados',
    TotalDocumentsQuantity = 'cantidadDocumentosTotal',
    CompletedTasksQuantity = 'cantidadTareasCompletadas',
    TotalTasksQuantity = 'cantidadTareasTotal',
    IncomeCertifications = 'certificacionIngresos',
    MonotaxCategory = 'categoriaMonotributo'
}


export interface Solicitation extends EntityWithId<number> {
    [SolicitationFields.SolicitationChannelCode]: number;
    [SolicitationFields.SolicitationClientId]: number;
    [SolicitationFields.SolicitationStateCode]: SolicitudPreviewEstados;
    [SolicitationFields.SolicitationTypeCode]: number;
    [SolicitationFields.AfipActivityCode]: number ;
    [SolicitationFields.AnualIncome]: number;
    [SolicitationFields.BeginDate]: string;
    [SolicitationFields.RegisterUserId]: number;
    [SolicitationFields.LastModifiedUserId]: number;
    [SolicitationFields.NosisDataConsulted]: boolean;
    [SolicitationFields.OriginId]: string;
    [SolicitationFields.SolicitationGuaranteeTypeCode]: number;
    [SolicitationFields.EmployeeQuantity]: number;
    [SolicitationFields.NewEmployeeQuantity]: number ;
    [SolicitationFields.CommercialOriginId]: number ;
    [SolicitationFields.InstallmentCTAmount]: number;
    [SolicitationFields.InstallmentInvAmount]: number;
    [SolicitationFields.InstallmentAgroAmount]: number;
    [SolicitationFields.BankCode]: number;
    [SolicitationFields.BranchCode]: number;
    [SolicitationFields.CommercialId]: number;
    [SolicitationFields.TitularId]: number;
    [SolicitationFields.TitularBusinessName]: string;
    [SolicitationFields.TitularCUIT]: string;
    [SolicitationFields.SolicitationStateDesc]: string;
    [SolicitationFields.SolicitationTypeDesc]: string;
    [SolicitationFields.RegisterUser]: string;
    [SolicitationFields.SolicitationGuaranteeTypeDesc]: string;
    [SolicitationFields.BankDesc]: string;
    [SolicitationFields.BranchDesc]: string;
    [SolicitationFields.CurrentStage]: string;
    [SolicitationFields.AfipActivityDesc]: string;
    [SolicitationFields.AfipAreaDesc]: string;
    [SolicitationFields.AfipSectorDesc]: string;
    [SolicitationFields.SolicitationChannelDesc]: string;
    [SolicitationFields.ModuleCode]: number;
    [SolicitationFields.CommunicationChannelCode]: number;
    [SolicitationFields.GenderQuota]: number;
    [SolicitationFields.HasCoOwner]?: boolean;
    [SolicitationFields.ExternalResponsibleUser]: string;
    [SolicitationFields.ExternalResponsibleUserId]: number;
    [SolicitationFields.Mail]: string;
    [SolicitationFields.Amount]: number;
    [SolicitationFields.OperationDestinationReasonDesc]: string;
    [SolicitationFields.OperationDestinationDesc]: string;
    [SolicitationFields.SentDate]: Date;
    [SolicitationFields.HasActiveNotification]: boolean;
    [SolicitationFields.AchievedDocumentsQuantity]: number;
    [SolicitationFields.TotalDocumentsQuantity]: number;
    [SolicitationFields.CompletedTasksQuantity]: number;
    [SolicitationFields.TotalTasksQuantity]: number;
    [SolicitationFields.IncomeCertifications]?: number;
    [SolicitationFields.MonotaxCategory]?: number;
}

export enum SolicitationMailInsertDTOFields {
    ClientId = 'idCliente',
    MailId = 'idClienteMail',
    PreviousMailId = 'idSolicitudClienteMailAnterior'
}

export interface SolicitationMailInsertDTO {
    [SolicitationMailInsertDTOFields.ClientId]: number;
    [SolicitationMailInsertDTOFields.MailId]: number;
    [SolicitationMailInsertDTOFields.PreviousMailId]: number;
}

export enum ClientConfirmationFields {
    ConfirmedName = 'bitConfirmaNombre',
    ConfirmedCuit = 'bitConfirmaCuit',
    ConfirmedActivity = 'bitConfirmaActividad',
    ConfirmedAddress = 'bitConfirmarDireccion'
}

export interface SolicitationClientInsertDTO extends EntityWithId<number> {
    [SolicitationFields.SolicitationChannelCode]: Channels;
    [SolicitationFields.BankCode]: number | null;
    [SolicitationFields.BranchCode]: number | null;
    [SolicitationFields.SolicitationStateCode]: number;
    [SolicitationFields.SolicitationTypeCode]: number;
    [SolicitationFields.AfipActivityCode]: number;
    [SolicitationFields.AnualIncome]: number;
    [SolicitationFields.OriginId]: string;
    [SolicitationFields.SolicitationGuaranteeTypeCode]: number;
    [SolicitationFields.NewEmployeeQuantity]: number;
    [SolicitationFields.CommunicationChannelCode]: number | null;
    [SolicitationFields.EmployeeQuantity]: number;
    [SolicitationFields.GenderQuota]: number;
    [SolicitationFields.InstallmentCTAmount]: number | null;
    [SolicitationFields.InstallmentInvAmount]: number | null;
    [SolicitationFields.InstallmentAgroAmount]: number | null;
    [SolicitationFields.CommercialId]: number | null;
    [SolicitationFields.ModuleCode]: number;
    [SolicitationFields.TitularId]?: number;
    [SolicitationFields.TitularBusinessName]?: string;
    [SolicitationFields.TitularCUIT]?: string;
    [SolicitationFields.IncomeCertifications]?: number;
    [SolicitationFields.MonotaxCategory]?: number;
    [ClientFields.CommercialName]?: string;
    [ClientFields.Website]?: string;
    [ClientFields.MaritalStatusCode]?: number;
    [ClientFields.ClientClassificationCode]?: number;
    [ClientFields.AfipResponsibilityTypeCode]?: number;
    [ClientFields.BirthDate]?: Date;
    [SolicitationFields.Mail]: string;
    [ClientConfirmationFields.ConfirmedName]?: boolean;
    [ClientConfirmationFields.ConfirmedCuit]?: boolean;
    [ClientConfirmationFields.ConfirmedActivity]?: boolean;
    [ClientConfirmationFields.ConfirmedAddress]?: boolean;
}

export enum SolicitationClientFields {
    Id = 'id',
    ClientId = "idCliente",
    SolicitationId = 'idSolicitud',
    BusinessName = 'razonSocial',
    IdentificationNumber = 'numeroDocumento',
    CUIT = 'cuit',
    IncomeTaxRegistered = 'estaInscriptoEnGanancias',
    GrossIncomeRegistered = 'estaInscriptoEnIngresosBrutos',
    BlockedEmail = 'tieneMailBloqueo',
    ActivityStartDate = 'actividadFechaInicio',
    AfipRegisterDate = 'afipFechaInscripcion',
    BirthDate = 'fechaNacimiento',

    ClientTypeCode = 'codClienteTipo',
    ClientTypeDesc = 'descClienteTipo',
    ClientClassificationCode = 'codClienteClasificacion',
    ClientClassificationDesc = 'descClienteClasificacion',
    AfipResponsibilityTypeCode = 'codAfipResponsableTipo',
    AfipResponsibilityTypeDesc = 'descAfipResponsableTipo',
    MaritalStatusCode = 'codEstadoCivil',
    MaritalStatusDesc = 'descEstadoCivil',
    NationalityCode = 'codNacionalidad',
    GenderCode = 'codClienteGenero',
    RelationshipTypeCode = "codClienteRelacionTipo",
    RelationshipTypeDesc = "descClienteRelacionTipo",
    RelationshipClassificationCode = "codClienteRelacionClasificacion",
    RelationshipClassificationDesc = "descClienteRelacionClasificacion",
    Participation = "porcParticipacion",

    AfipMainActivityDesc = 'descAfipActividadPrincipal',
    AfipAreaDesc = 'descAfipRubro',
    AfipSectorDesc = 'descAfipSector',
    AfipSepymeDesc = 'descAfipRamoSepyme',
    AfipStretchCode = 'codAfipTramo',
    AfipStretchDesc = 'descAfipTramo',
    PymeCertificateNumber = 'vchNroCertificadoPyme',
    PymeCertificateDate = 'dtmFechaCertificadoPyme',
    PymeCertificateIssueDate = 'dtmFechaEmisionCertificadoPyme',
    SepymeCertificate = 'vchAfipRamoSepymeCertificado',
    AfipStretchCertificate = 'vchDescAfipTramoCertificadoPyme',
    Address = 'domicilio',
    FianceCuit = 'cuitConyugue',
    FianceName = 'razonSocialConyugue',
    Active = "estaActivo",
    ModifiedDate = "fechaModificacion",
}

export interface SolicitationClient extends EntityWithId<number> {
    [SolicitationClientFields.ClientId]: number;
    [SolicitationClientFields.SolicitationId]: number;
    [SolicitationClientFields.RelationshipTypeCode]: number;
    [SolicitationClientFields.RelationshipTypeDesc]: string;
    [SolicitationClientFields.RelationshipClassificationCode]: number;
    [SolicitationClientFields.RelationshipClassificationDesc]: string;
    [SolicitationClientFields.Participation]: number;
    [SolicitationClientFields.BusinessName]: string;
    [SolicitationClientFields.IdentificationNumber]: string;
    [SolicitationClientFields.CUIT]: string;
    [SolicitationClientFields.IncomeTaxRegistered]: boolean;
    [SolicitationClientFields.GrossIncomeRegistered]: boolean;
    [SolicitationClientFields.BlockedEmail]: boolean;
    [SolicitationClientFields.ActivityStartDate]: Date;
    [SolicitationClientFields.AfipRegisterDate]: Date ;
    [SolicitationClientFields.ClientTypeCode]: number;
    [SolicitationClientFields.ClientTypeDesc]: string;
    [SolicitationClientFields.ClientClassificationCode]: number;
    [SolicitationClientFields.ClientClassificationDesc]: string;
    [SolicitationClientFields.AfipResponsibilityTypeCode]: number;
    [SolicitationClientFields.MaritalStatusDesc]: string;
    [SolicitationClientFields.MaritalStatusCode]: number;
    [SolicitationClientFields.AfipMainActivityDesc]: string;
    [SolicitationClientFields.AfipAreaDesc]: string;
    [SolicitationClientFields.AfipSectorDesc]: string;
    [SolicitationClientFields.AfipSepymeDesc]: string;
    [SolicitationClientFields.AfipStretchDesc]: string;
    [SolicitationClientFields.PymeCertificateNumber]: string;
    [SolicitationClientFields.PymeCertificateDate]: string;
    [SolicitationClientFields.PymeCertificateIssueDate]: string;
    [SolicitationClientFields.SepymeCertificate]: string;
    [SolicitationClientFields.AfipStretchCertificate]: string;
    [SolicitationClientFields.Active]: boolean;
    [SolicitationClientFields.ModifiedDate]: Date;
    [SolicitationClientFields.GenderCode]: number;
    [SolicitationClientFields.Address]: string;
    [SolicitationClientFields.FianceCuit]: string;
    [SolicitationClientFields.FianceName]: string;
}


export interface WorkflowSolicitationDTO {
    [SolicitationFields.BankCode]: number,
    [SolicitationFields.BranchCode]?: number,
    [SolicitationFields.SolicitationTypeCode]: number,
    [ClientFields.BusinessName]: string,
    [ClientFields.CUIT]: string
}

export enum SolicitationRequestDocumentationPostFields {
    FileTypeCode = 'codArchivoTipo',
    RequestDocumentationDesc = 'descPedidoDocumentacion',
}


export interface SolicitationRequestDocumentationPost {
    [SolicitationRequestDocumentationPostFields.FileTypeCode]: number,
    [SolicitationRequestDocumentationPostFields.RequestDocumentationDesc]: string,
}

export enum SolicitationRequestDocumentationViewFields {
    SolicitationId = 'idSolicitud',
    FileTypeCode = 'codArchivoTipo',
    RequestDocumentationDesc = 'descPedidoDocumentacion',
    NewUserId = 'idUsuarioAlta',
    NewDate = 'fechaAlta',
    FileTypeDesc = 'descArchivoTipo',
    NewUser = 'usuarioAlta',
    AchievedDocumentsQuantity = 'cantArchivosAnexados'
}

export interface SolicitationRequestDocumentationView extends EntityWithId<number> {
    [SolicitationRequestDocumentationViewFields.SolicitationId]: number,
    [SolicitationRequestDocumentationViewFields.FileTypeCode]: number,
    [SolicitationRequestDocumentationViewFields.RequestDocumentationDesc]: string,
    [SolicitationRequestDocumentationViewFields.NewUserId]: number,
    [SolicitationRequestDocumentationViewFields.NewDate]: Date,
    [SolicitationRequestDocumentationViewFields.FileTypeDesc]: string,
    [SolicitationRequestDocumentationViewFields.NewUser]: string,
    [SolicitationRequestDocumentationViewFields.AchievedDocumentsQuantity]: number
}

export enum SolicitationFileRequestedViewFields {
    RequestDocumentationId = 'idSolicitudPedidoDocumentacion'
}


export interface SolicitationFileRequestedView extends FileBase {
    [SolicitationFileRequestedViewFields.RequestDocumentationId]: number
}



export enum SolicitationOperationViewDetailFields {
    Id = 'id',
    Description = 'descripcion',
    SolicitationId = 'idSolicitud',
    FinanceAmount = 'importeAFinanciar',
    GuaranteeAmount = 'importeGarantia',
    GuaranteePercentage = 'porcGarantia',
    InstallmentAmount = 'importeCuota',
    MonthlyInstallmentAmount = 'importeCuotaMensual',
    ActionsAmount = 'importeAcciones',
    CommissionsAmount = 'importeComisiones',
    BusinessName = 'razonSocial',
    CUIT = 'cuit',
    OperationState = 'descSolicitudOperacionEstado',
    OperationBankDesc = 'bancoNombre',
    OperationBankBranchDesc = 'bancoSucursalNombre',
    Rate = 'porcTasa',
    VariableRate = 'porcTasaVariable',
    MonthsAtFixedRate = 'mesesTasaFija',
    AdditionalRate = 'porcTasaAdicional',
    RateObservations = 'tasaObservaciones',
    Term = 'plazo',
    GracePeriod = 'mesesGracia',
    WorkingCapitalIndexAmountToFinance = 'capitalDeTrabajoIndiceMontoAFinanciar',
    WorkingCapitalIndexMonthlyInstallment = 'capitalDeTrabajoIndiceCuotaMensual',
    WorkingCapitalApproved = 'capitalDeTrabajoAprobado',
    InvestmentProjectIndexMonthlyPayment = 'proyectoInversionIndiceCuotaMensual',
    InvestmentProjectAmount = 'proyectoInversionMonto',
    InvestmentProjectDetail = 'proyectoInversionDetalle',
    InvestmentProjectApproved = 'proyectoInversionAprobado',
    AgriculturalIndexGrossIncome = 'agropecuarioIndiceIngresosBrutos',
    AgriculturalApproved = 'agropecuarioAprobado',
    OperationWorkFlowId = 'idOperacionWorkFlow',
    FogabaOperationId = 'idOperacionFogaba',
    OperationOriginId = 'idOperacionEnOrigen',
    FogabaRegisterDate = 'fechaAltaFogaba',
    MonetizationDate = 'fechaMonetizacion',
    OriginRegisterDate = 'fechaAltaEnOrigen',
    HasCancelledCommission = 'tieneComisionCancelada',
    HasCancelledAction = 'tieneAccionCancelada',
    Desisted = 'estaDesistida',
    LineDesc = 'descLinea',
    SubLine = 'descLineaSub',
    SolicitationOperationTypeDesc = 'descSolicitudOperacionTipo',
    AmortizationSystemDesc = 'descSistemaAmortizacion',
    Periodicity = 'descPeriodicidad',
    RateMode = 'descTasaModo',
    RateTypeDesc = 'descTasaTipo',
    CurrencyDesc = 'descMoneda',
    DesistedDesc = 'descDesistimiento',
    SolicitationOperationCancellationTypeCode = 'codSolicitudOperacionCancelacionTipo'
}

export interface SolicitationOperationViewDetail extends EntityWithIdAndDescription {
    [SolicitationOperationViewDetailFields.Id]: number,
    [SolicitationOperationViewDetailFields.Description]: string,
    [SolicitationOperationViewDetailFields.SolicitationId]: number,
    [SolicitationOperationViewDetailFields.FinanceAmount]: number,
    [SolicitationOperationViewDetailFields.GuaranteeAmount]: number,
    [SolicitationOperationViewDetailFields.GuaranteePercentage]: number,
    [SolicitationOperationViewDetailFields.InstallmentAmount]: number,
    [SolicitationOperationViewDetailFields.MonthlyInstallmentAmount]: number,
    [SolicitationOperationViewDetailFields.ActionsAmount]: number,
    [SolicitationOperationViewDetailFields.CommissionsAmount]: number,
    [SolicitationOperationViewDetailFields.BusinessName]: string,
    [SolicitationOperationViewDetailFields.CUIT]: string,
    [SolicitationOperationViewDetailFields.OperationState]: string,
    [SolicitationOperationViewDetailFields.OperationBankDesc]: string,
    [SolicitationOperationViewDetailFields.OperationBankBranchDesc]: string,
    [SolicitationOperationViewDetailFields.Rate]: number | null,
    [SolicitationOperationViewDetailFields.VariableRate]: number,
    [SolicitationOperationViewDetailFields.MonthsAtFixedRate]: number | null,
    [SolicitationOperationViewDetailFields.AdditionalRate]: number,
    [SolicitationOperationViewDetailFields.RateObservations]: string,
    [SolicitationOperationViewDetailFields.Term]: number,
    [SolicitationOperationViewDetailFields.GracePeriod]: number,
    [SolicitationOperationViewDetailFields.WorkingCapitalIndexAmountToFinance]: number | null,
    [SolicitationOperationViewDetailFields.WorkingCapitalIndexMonthlyInstallment]: number | null,
    [SolicitationOperationViewDetailFields.WorkingCapitalApproved]: boolean | null,
    [SolicitationOperationViewDetailFields.InvestmentProjectIndexMonthlyPayment]: number,
    [SolicitationOperationViewDetailFields.InvestmentProjectAmount]: number,
    [SolicitationOperationViewDetailFields.InvestmentProjectDetail]: string,
    [SolicitationOperationViewDetailFields.InvestmentProjectApproved]: boolean | null,
    [SolicitationOperationViewDetailFields.AgriculturalIndexGrossIncome]: number | null,
    [SolicitationOperationViewDetailFields.AgriculturalApproved]: boolean | null,
    [SolicitationOperationViewDetailFields.OperationWorkFlowId]: number,
    [SolicitationOperationViewDetailFields.FogabaOperationId]: number | null,
    [SolicitationOperationViewDetailFields.OperationOriginId]: string,
    [SolicitationOperationViewDetailFields.FogabaRegisterDate]: string | null,
    [SolicitationOperationViewDetailFields.MonetizationDate]: string | null,
    [SolicitationOperationViewDetailFields.OriginRegisterDate]: string | null,
    [SolicitationOperationViewDetailFields.HasCancelledCommission]: boolean,
    [SolicitationOperationViewDetailFields.HasCancelledAction]: boolean,
    [SolicitationOperationViewDetailFields.Desisted]: boolean,
    [SolicitationOperationViewDetailFields.LineDesc]: string,
    [SolicitationOperationViewDetailFields.SubLine]: string | null,
    [SolicitationOperationViewDetailFields.SolicitationOperationTypeDesc]: string,
    [SolicitationOperationViewDetailFields.AmortizationSystemDesc]: string,
    [SolicitationOperationViewDetailFields.Periodicity]: string,
    [SolicitationOperationViewDetailFields.RateMode]: string,
    [SolicitationOperationViewDetailFields.RateTypeDesc]: string,
    [SolicitationOperationViewDetailFields.CurrencyDesc]: string,
    [SolicitationOperationViewDetailFields.DesistedDesc]: string,
    [SolicitationOperationViewDetailFields.SolicitationOperationCancellationTypeCode]: number,
}

export enum SolicitationStatusViewDTOFields {
    PendantDocumentsQuantity = "cantPedidosDocumentacionPendientes",
    PendantTasksQuantity = 'cantTareasPendientes',
    CanApproveOperation = 'puedeAprobarOperacion',
    OperationApproved = 'aproboOperacion'
}


export interface SolicitationStatusViewDTO {
    [SolicitationStatusViewDTOFields.PendantDocumentsQuantity]: number,
    [SolicitationStatusViewDTOFields.PendantTasksQuantity]: number,
    [SolicitationStatusViewDTOFields.CanApproveOperation]: boolean,
    [SolicitationStatusViewDTOFields.OperationApproved]: boolean | null
}